import { useEffect, useState } from 'react';
import { AlertCircle, ShieldCheck } from 'lucide-react';
import { api } from '../lib/api';

export function TradingModeBadge() {
  const [tradingMode, setTradingMode] = useState<string | undefined>();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadTradingMode = async () => {
      try {
        const status = await api.getMe();
        setTradingMode(status.trading_mode);
      } catch (error) {
        console.error('Error loading trading mode:', error);
      } finally {
        setLoading(false);
      }
    };

    loadTradingMode();
    // Refresh every 30 seconds
    const interval = setInterval(loadTradingMode, 30000);
    return () => clearInterval(interval);
  }, []);

  if (loading || !tradingMode) {
    return null;
  }

  const isPaper = tradingMode === 'PAPER';

  return (
    <div
      className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-sm font-semibold shadow-sm ${
        isPaper
          ? 'bg-emerald-100 text-emerald-800 border border-emerald-300'
          : 'bg-red-100 text-red-800 border border-red-300'
      }`}
    >
      {isPaper ? (
        <>
          <ShieldCheck className="w-4 h-4" />
          <span>PAPER Mode</span>
        </>
      ) : (
        <>
          <AlertCircle className="w-4 h-4" />
          <span>LIVE Trading</span>
        </>
      )}
    </div>
  );
}
